import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import ContactPage from './pages/contactPage';
import Home from './pages/home/home';
import './App.scss';
import FaqPage from './pages/faq/faqPage';
import LegalPage from './pages/legal/legalPage';
import AboutPage from './pages/about/aboutPage';
import IOSInvitation from './pages/iOSInvitation/iOSInvitation';
import { LanguageProvider } from './services/LanguageContext'; // Import LanguageProvider
import Layout from './pages/layout';
import BridgePage from './pages/other/bridgePage';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          {/* Redirect root to default language */}
          <Route path="/" element={<Navigate replace to="/de" />} />

          {/* Define a route that uses the Layout */}
          <Route path="/:lang" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="legal/:pageType" element={<LegalPage />} />
            <Route path="iOSInvitation" element={<IOSInvitation />} />
            <Route path="Anmeldung" element={<BridgePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
